var React = require('react');

function ButtonFormIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_ionic-ios-arrow-back","data-name":"Icon ionic-ios-arrow-back","d":"M2.538,7.361,8.11,1.794A1.052,1.052,0,0,0,6.619.307L.307,6.616A1.05,1.05,0,0,0,.276,8.067l6.339,6.352a1.052,1.052,0,0,0,1.491-1.486Z","transform":"translate(8.919 15.227) rotate(180)","fill":"#fff","stroke":"#fff","strokeWidth":"1"}));
}

ButtonFormIcon.defaultProps = {"width":"9.501","height":"15.82","viewBox":"0 0 9.501 15.82"};

module.exports = ButtonFormIcon;

ButtonFormIcon.default = ButtonFormIcon;
